var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSec02Img(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.333,
    height: 134.676,
    viewBox: "0 0 108.333 134.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_179",
    "data-name": "\\u9577\\u65B9\\u5F62 179",
    width: 108.333,
    height: 134.676,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec02img",
    transform: "translate(-921.167 -1360.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_153",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 153",
    transform: "translate(921.167 1360.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_378",
    "data-name": "\\u30D1\\u30B9 378",
    d: "M43.558,97.9l4.026-9.413,2.325-12.362,2.949-3.629,7.031-2.948-2.041-4.99L54.673,52.079,66.014,36.655l29.033,6.124,8.846,11.114-1.134,6.8L97.315,67.73,94.2,71.3l-5.273,5.728,2.268,8.846L111.832,107.2l1.815,32.209-59.427-3.629Z",
    transform: "translate(-20.917 -17.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_150",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_149",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 149",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_379",
    "data-name": "\\u30D1\\u30B9 379",
    d: "M105.17,160.9c-1.191-4.933-3.913-24.327-5.1-26.2s-5.1-3.743-5.1-3.743l-20.584-4.933-4.424-3.4-3.913,3.4-6.8,4.593-9.7-7.315-3.913,3.573-2.552,3.913-2.892,1.531-1.871-3.4-.51,5.614-3.4,3.913-1.531.17.17,2.552-8.506-4.933,2.722-6.465s-6.635,1.7-9.186,4.423S6.5,155.962,3.951,158.854.038,171.442,2.589,178.247s8.676,6.124,11.738,6.124,6.975-4.083,6.975-4.083l5.784-10.717.51,21.784h80.975s-2.211-25.527-3.4-30.46m-67.026-1.361-6.124-1.7,2.722-6.8H47.16l.34,5.444Zm39.637.68-8.506-3.4-.17-5.614,17.182-.34.68,5.784Z",
    transform: "translate(-0.589 -58.882)",
    fill: "#72acd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_380",
    "data-name": "\\u30D1\\u30B9 380",
    d: "M67.063,21.274l1.191-9.867s6.464-5.784,7.655-6.634S83.734,1.2,83.734,1.2l11.908.34s8.166,4.083,10.037,4.933,5.1,2.552,5.273,3.913,1.871,7.825,1.871,9.7.51,10.717.51,10.717L108.4,26.377l-2.722,3.062L85.435,25.867l-4.933.51-6.8-1.191-6.465,3.4-5.1.51-.68-2.382Z",
    transform: "translate(-29.508 -0.576)",
    fill: "#72acd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_381",
    "data-name": "\\u30D1\\u30B9 381",
    d: "M143.268,52.869l2.382,10.717,3.913-3.913,1.361,2.211.851-3.232-.171-5.614-3.913-3.4-1.7,2.722Z",
    transform: "translate(-68.797 -23.835)",
    fill: "#5a6468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_382",
    "data-name": "\\u30D1\\u30B9 382",
    d: "M144.719,83.684l2.892-1.191,2.722-3.4-2.552,6.975-3.573,3.573-3.232,2.041Z",
    transform: "translate(-67.697 -37.98)",
    fill: "#5a6468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_383",
    "data-name": "\\u30D1\\u30B9 383",
    d: "M76.463,47.845a12.769,12.769,0,1,0,13,12.767,12.885,12.885,0,0,0-13-12.767m0,22.026a9.26,9.26,0,1,1,9.429-9.259,9.345,9.345,0,0,1-9.429,9.259",
    transform: "translate(-30.474 -22.975)",
    fill: "#85bab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_384",
    "data-name": "\\u30D1\\u30B9 384",
    d: "M77.669,95.127l-.51,2.212,4.083.68.85-2.212Z",
    transform: "translate(-37.051 -45.68)",
    fill: "#85bab0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_152",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_151",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 151",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_385",
    "data-name": "\\u30D1\\u30B9 385",
    d: "M128.5,67.354a1.593,1.593,0,1,1-1.593-1.593,1.593,1.593,0,0,1,1.593,1.593",
    transform: "translate(-60.177 -31.578)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_386",
    "data-name": "\\u30D1\\u30B9 386",
    d: "M95.159,67.865a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1",
    transform: "translate(-43.675 -31.579)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_387",
    "data-name": "\\u30D1\\u30B9 387",
    d: "M89.192,63.853a9.43,9.43,0,1,1-9.429-9.259A9.345,9.345,0,0,1,89.192,63.853Z",
    transform: "translate(-33.774 -26.216)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_14",
    "data-name": "\\u6955\\u5186\\u5F62 14",
    cx: 13.001,
    cy: 12.767,
    rx: 13.001,
    ry: 12.767,
    transform: "translate(32.987 24.87)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_388",
    "data-name": "\\u30D1\\u30B9 388",
    d: "M18.359,145.309S3.389,168.218,1.8,175.93.667,189.539,6.11,193.622s12.475.681,15.2-2.5S38.093,153.7,38.093,153.7l-15.651-6.124L5.2,174.115",
    transform: "translate(-0.48 -69.777)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_389",
    "data-name": "\\u30D1\\u30B9 389",
    d: "M46.177,125.576c3.629-5.9,4.536-19.053,5.671-20.187s9.073-5.9,10.207-5.9,9.754,5.444,9.3,6.578-1.757,2.552-3.119,1.02-5.1-2.892-5.1-2.892l-1.7,1.02",
    transform: "translate(-22.174 -47.775)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_390",
    "data-name": "\\u30D1\\u30B9 390",
    d: "M63.413,112.38l7.485-1.871s4.763,2.722,4.933,3.232-1.191,3.062-1.191,3.062",
    transform: "translate(-30.451 -53.066)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_391",
    "data-name": "\\u30D1\\u30B9 391",
    d: "M64.722,117.957l5.1-2.212,5.614,4.763-.85,2.722",
    transform: "translate(-31.079 -55.581)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_392",
    "data-name": "\\u30D1\\u30B9 392",
    d: "M63.661,125.459l5.1-1.531a7.736,7.736,0,0,1,4.593,4.763c.51,1.7-3.913,4.763-4.424,3.573l-1.19-2.212.85-1.361-1.191-.51s-.17,5.784-.17,6.635-3.913,5.273-4.593,4.593-1.191,2.042-1.191,2.042",
    transform: "translate(-29.508 -59.51)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_18",
    "data-name": "\\u7DDA 18",
    y2: 22.625,
    transform: "translate(26.668 110.519)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_19",
    "data-name": "\\u7DDA 19",
    y1: 1.871,
    x2: 5.103,
    transform: "translate(21.734 70.712)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_393",
    "data-name": "\\u30D1\\u30B9 393",
    d: "M95.158,92.4s3.062,3.4,9.7,3.4S120,88.823,122.377,79.127c2.892,0,5.546-3.941,5.1-7.485a2.961,2.961,0,0,0-1.531-2.042",
    transform: "translate(-45.695 -33.422)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_394",
    "data-name": "\\u30D1\\u30B9 394",
    d: "M142.613,55.527l2.892,11.058s3.572-4.253,4.083-4.763",
    transform: "translate(-68.483 -26.664)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_395",
    "data-name": "\\u30D1\\u30B9 395",
    d: "M66.112,28.53c-2.324.382-3.949.644-4.089.644-.51,0-1.191-1.7-.51-3.062l4.933-4.083,1.7-9.7c.85-3.233,9.186-9.7,14.8-11.058,2.149-.521,11.4-.17,12.249,0s11.738,3.743,14.97,8.846S113.228,30.7,113.228,30.7s-5.954-5.614-7.655-6.464-12.079-5.954-16.672-6.8-19.564,3.572-21.435,4.253",
    transform: "translate(-29.401 -0.48)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_396",
    "data-name": "\\u30D1\\u30B9 396",
    d: "M125.984,49.343s-1.871,2.382-2.892,2.722-17.182-3.913-20.924-3.743c-.46.021-2.17.271-4.458.631",
    transform: "translate(-46.92 -23.202)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_397",
    "data-name": "\\u30D1\\u30B9 397",
    d: "M150.673,57.491c.68,2.722-1.191,12.929-1.531,14.12a33.521,33.521,0,0,1-5.1,7.485l-3.062,2.552",
    transform: "translate(-67.697 -27.607)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_20",
    "data-name": "\\u7DDA 20",
    x1: 0.907,
    y2: 1.758,
    transform: "translate(39.88 49.958)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_21",
    "data-name": "\\u7DDA 21",
    x1: 0.85,
    y2: 2.382,
    transform: "translate(43.85 50.638)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_398",
    "data-name": "\\u30D1\\u30B9 398",
    d: "M99.413,98.319c2.212,1.361,5.614,1.021,7.655,1.191s5.784-.68,7.656-2.382",
    transform: "translate(-47.738 -46.641)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_22",
    "data-name": "\\u7DDA 22",
    x2: 2.212,
    y2: 1.531,
    transform: "translate(56.608 45.194)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_23",
    "data-name": "\\u7DDA 23",
    x2: 1.021,
    y2: 3.232,
    transform: "translate(38.066 48.597)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_24",
    "data-name": "\\u7DDA 24",
    x2: 0.17,
    y2: 4.253,
    transform: "translate(50.144 60.165)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_25",
    "data-name": "\\u7DDA 25",
    y2: 4.253,
    transform: "translate(68.006 59.484)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_399",
    "data-name": "\\u30D1\\u30B9 399",
    d: "M115.777,129.488c1.361-.51,8.676-7.145,9.186-8.506,0,0,4.423,4.423,4.763,5.614s-7.485,14.97-7.485,14.97l-5.614-8.336",
    transform: "translate(-55.596 -58.095)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_400",
    "data-name": "\\u30D1\\u30B9 400",
    d: "M99.251,133.165l-6.124,9.526-6.8-15.991,4.083-4.083s7.315,6.124,9.016,7.315",
    transform: "translate(-41.452 -58.881)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_401",
    "data-name": "\\u30D1\\u30B9 401",
    d: "M140.322,127.855s21.435,4.933,22.625,6.124",
    transform: "translate(-67.382 -61.396)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_402",
    "data-name": "\\u30D1\\u30B9 402",
    d: "M191.7,145.2c3.573,7.826,8.166,57.159,8.166,57.159",
    transform: "translate(-92.056 -69.725)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_403",
    "data-name": "\\u30D1\\u30B9 403",
    d: "M177.9,149.782c-.51,2.892-7.145,53.747-7.145,56.3",
    transform: "translate(-81.998 -71.925)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_404",
    "data-name": "\\u30D1\\u30B9 404",
    d: "M112.032,147.491s1.021,6.294,1.021,7.315a66.571,66.571,0,0,1-1.531,6.634l1.191,42.189",
    transform: "translate(-53.553 -70.825)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_405",
    "data-name": "\\u30D1\\u30B9 405",
    d: "M131.813,177.6h17.862v5.444s-8.336,2.892-9.527,2.722-8.336-2.722-8.336-2.722Z",
    transform: "translate(-63.296 -85.283)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_406",
    "data-name": "\\u30D1\\u30B9 406",
    d: "M133.777,189.382v12.929a25.191,25.191,0,0,0,8.166,1.871,27.948,27.948,0,0,0,8-1.531V189.382",
    transform: "translate(-64.24 -90.941)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_407",
    "data-name": "\\u30D1\\u30B9 407",
    d: "M63.2,177.6H75.954v5.444s-8.336,2.892-9.526,2.722c-.7-.1-3.442-1.018-5.593-1.761",
    transform: "translate(-29.213 -85.283)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_408",
    "data-name": "\\u30D1\\u30B9 408",
    d: "M57.522,193.635v8.676a25.191,25.191,0,0,0,8.166,1.871,27.948,27.948,0,0,0,8-1.531V189.382",
    transform: "translate(-27.622 -90.941)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_409",
    "data-name": "\\u30D1\\u30B9 409",
    d: "M123.306,53.387a3.666,3.666,0,0,1,4.452.085,7.161,7.161,0,0,1,2.109,2.038",
    transform: "translate(-59.211 -25.295)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_410",
    "data-name": "\\u30D1\\u30B9 410",
    d: "M138.358,11.673c1.021.51,3.913,3.232,4.423,4.933s1.191,9.016,1.191,9.016",
    transform: "translate(-66.439 -5.605)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec02Img);
export default __webpack_public_path__ + "static/media/sec02img.b776921be13fabebcc0ebea227b987a8.svg";
export { ForwardRef as ReactComponent };